import constants from '../constants.js';

const ModifiedOn = {
  displayName: 'Modified on',
  dataAt: 'ModifiedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ModifiedBy = {
  displayName: 'Modified by',
  dataAt: 'ModifiedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedOn = {
  displayName: 'Created on',
  dataAt: 'CreatedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedBy = {
  displayName: 'Created by',
  dataAt: 'CreatedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const Id = {
  displayName: 'Identifier',
  dataAt: 'Id',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AdminPanel = {
  tabName: 'Admin',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CreatedBy, CreatedOn, ModifiedBy, ModifiedOn]
};

const ExpiryYear = {
  displayName: 'Expiry Year',
  dataAt: 'ExpiryYear',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'expiryYears',
  required: true
};

const ExpiryMonth = {
  displayName: 'Expiry Month',
  dataAt: 'ExpiryMonth',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'expiryMonths',
  required: true
};

const DisplayNumber = {
  displayName: 'Card Number',
  dataAt: 'DisplayNumber',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const CardHolder = {
  displayName: 'Card Holder',
  dataAt: 'CardHolder',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const CardType = {
  displayName: 'Card Type',
  dataAt: 'CardType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'cardType',
  required: true
};

const CardTitle = {
  displayName: 'Card Title',
  dataAt: 'Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const Remarks = {
  displayName: 'Remarks',
  dataAt: 'Remarks',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreditCardInfoPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Info',
  children: [Id, CardTitle, CardType, CardHolder,Remarks, DisplayNumber, ExpiryMonth, ExpiryYear]
};

const CreditCardTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [CreditCardInfoPanel, AdminPanel]
};

const CreditCardsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Credit Card',
  data:
    {
      CardType: '',
      CardHolder: '',
      DisplayNumber: '',
      ExpiryMonth: '',
      ExpiryYear: ''
    },
  dataAt: '',
  children: [CardTitle, CardType, CardHolder,Remarks, DisplayNumber, ExpiryMonth, ExpiryYear],
  endpoint: 'CreditCards'
};

const CreditCardsResource = {
  displayName: 'Credit Card',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [CreditCardTabs],
  endpoint: 'CreditCards',
  routeParamId: 'ccId',
  canDelete: true,
  deleteOnBackend: true
};

const CreditCardsList = {
  rootNode: true,
  displayName: 'Credit Cards',
  endpoint: 'CreditCards',
  iconClass: 'fa-credit-card',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: CreditCardsResource,
  gridAdd: CreditCardsAddResource,
  gridCols:
    [{name: 'Title', key: 'Title'},
      {name: 'Number', key: 'DisplayNumber'},
      {name: 'Card Holder', key: 'CardHolder'},
      {name: 'Remarks', key: 'Remarks'},
      {name: 'Card Type', key: 'CardType'},
      {name: 'Expiry Month', key: 'ExpiryMonth'},
      {name: 'Expiry Year', key: 'ExpiryYear'}]
};

export default {
  CreditCardsList,
  CreditCardsResource,
  CreditCardsAddResource,
  CreditCardTabs,
  CardTitle,
  CardType,
  CardHolder,
  DisplayNumber,
  ExpiryMonth,
  ExpiryYear,
  CreditCardInfoPanel,
  AdminPanel,
  Id,
  CreatedBy,
  CreatedOn,
  ModifiedBy,
  ModifiedOn
}


// WEBPACK FOOTER //
// ./src/config/fields/creditCards.js